import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DocketService } from '../../services/docket.service';
import { CustomerService } from '../../services/customer.service';
import { AddCustomerComponent } from '../../add-customer/add.customer.component';

@Component({
    selector: 'new-customer-dialog',
    template: `
    <add-customer
      [embeddedView]="true"
      (customerCreated)="created($event)"
      (canceled)="cancel()"
    ></add-customer>
  `,
    styleUrls: ['./new-customer-dialog.component.css'],
    providers: [DocketService, CustomerService],
    standalone: true,
    imports: [AddCustomerComponent]
})
export class NewCustomerDialogComponent {
  constructor(public dialogRef: MatDialogRef<NewCustomerDialogComponent>) {}

  cancel() {
    this.dialogRef.close();
  }

  created(customer) {
    this.dialogRef.close(customer);
  }
}
